import { Button, message, Modal, Select, Space, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import debounce from 'src/utils/debounce'
import { getGamesByCategory} from 'src/api/game'

import s from './index.module.scss'
import useForceRender from 'src/utils/ForceRender'
import { addToMainDiscovery, getDiscoveryEntityTypes, getEventsByProviderCountry, getExscapeGuys, getMetaversesMainDiscovery } from 'src/api/metaverse'
import { getMazes } from 'src/api/maze'
import { getTreasureHunter } from 'src/api/treasurehunter'
import ProviderCountrySelect from 'src/components/Input/ProviderCountrySelect'

const { Option } = Select
const { Title } = Typography

interface AddingModalProps {
  category: any
  visible: boolean
  onDone: () => void
  onCancel: () => void
  defaultProviderCountry?: string | null
}

const AddingModal: React.FC<AddingModalProps> = ({
  category,
  visible,
  onDone,
  onCancel,
  defaultProviderCountry
}) => {
  const forceRender = useForceRender()
  const selectedGame = React.useRef<MainDiscovery>(null)
  const selectedType = React.useRef<string>(null)
  const selectLoading = React.useRef<boolean>(false)
  const addLoading = React.useRef<boolean>(false)
  const games = React.useRef<MainDiscovery[]>([])
    const [listOfEntityTypes, setListOfEntityTypes] = useState([])
      const [providerCountry, setProviderCountry] = useState<string | null>(defaultProviderCountry ?? null)
const [events, setEvents] = useState<any[]>([])
const [selectedTypeState, setSelectedTypeState] = useState<string | null>(null)

      useEffect(() => {
    if (visible) {
      setProviderCountry(defaultProviderCountry ?? null)
    }
  }, [visible, defaultProviderCountry])
 useEffect(() => {
  const loadEvents = async () => {
    
    if (!visible) return
    if (selectedTypeState !== 'EVENT') return
    if (!providerCountry) return

    selectLoading.current = true
    forceRender()
   try {
      let res = null
      ;({ data: res } = await getEventsByProviderCountry(providerCountry))

      
      setEvents(Array.isArray(res?.data) ? res.data : [])
console.log('events state:', res?.data)

    } finally {
      selectLoading.current = false
      forceRender()
    }
  }

  loadEvents()
}, [providerCountry, visible, selectedTypeState])
 const handleModalCountryChange = (countriesList: string[]) => {
    setProviderCountry(countriesList?.[0] ?? null)
  }

  const handleSearch = async (value) => {
    selectLoading.current = true
    forceRender()
    let data = null;
   
    switch (selectedType.current) {
       
      case 'GAME':
        ({ data } = await getGamesByCategory(0, 50, value));
        break;
      case 'GUYS':
        ({ data } = await getExscapeGuys(0, 50, value));
        break;
      case 'MAZE':
        ({ data } = await getMazes(0, 50, value));
        break;
      case 'TREASURE':
        ({ data } = await getTreasureHunter(0, 50, value));
        break;
      case 'METAVERSE':
        ({ data } = await getMetaversesMainDiscovery(0, 50, value));
        break;
      case 'EVENT':
  if (!providerCountry) break
  ;({ data } = await getEventsByProviderCountry(providerCountry))
  
  break
    }
    

games.current = data;
    selectLoading.current = false
    forceRender()
  }

  const resetModal = React.useCallback(() => {
    selectedGame.current = null
    selectedType.current =null
    selectLoading.current = false
    addLoading.current = false
    games.current = []
    forceRender()
  }, [])

  const handleSelect = React.useCallback((option) => {
    
    selectedGame.current = {
      id: option.value,
      name: option.label,
      title: option.label,
      type:selectedType.current,
      
      roomId:selectedType?.current ==='METAVERSE'? option.value: null
    }
    
    forceRender()
  }, [])

  const handleAdd = React.useCallback(async () => {
    if (!selectedGame.current) {
      message.warn('Select an item first !')
      return
    }
    if (!providerCountry) {
      message.warn('Select provider country first!')
      return
    }
    addLoading.current = true
    forceRender()
    const gameIds = category?.Main.map((i) => i.id)
    await addToMainDiscovery(selectedGame.current?.id, selectedType?.current,providerCountry)
    message.success(
      `${selectedGame.current?.name} is added to ${category.type}`
    )
    resetModal()
    onDone && onDone()
  }, [selectedGame.current, category,providerCountry])

  const handleCancel = React.useCallback(() => {
    resetModal()
    onCancel && onCancel()
  }, [])

  const filteredResults = games.current?.filter((item) => {
   
   if(selectedType?.current === 'METAVERSE'){
    
    return !category?.Main.find((i) => i.entityId === item.roomId)
   }
    return !category?.Main.find((i) => i.entityId === item.id)
  })
  const filterEvents = React.useCallback(
  (eventsList: any[]) => {
    if (!Array.isArray(eventsList)) return []

    return eventsList.filter(
      (event) => !category?.Main?.find((i) => i.entityId === event.id)
    )
  },
  [category]
)
   useEffect(() => {
      const fetchDiscoveryEntityTypes = async () => {
        try {
          const data = await getDiscoveryEntityTypes()
          if (data) {
            setListOfEntityTypes(data)
          }
        } catch (error) {
          console.error('Error fetching discovery entity:', error)
        }
      }
  
      fetchDiscoveryEntityTypes()
    }, [])

    const handleTypeChange= React.useCallback((option) => {
        
        selectedType.current = (option)
        setSelectedTypeState(option)
        forceRender()
      }, [])

  return (
    <>
      <Modal
        title={`Add  to ${category?.type}`}
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button
            type="primary"
            key="add"
            onClick={handleAdd}
            loading={addLoading.current}
          >
            Add
          </Button>,
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Title level={5}>{category?.Main?.length} items added</Title>
        <Space direction="vertical" >
          
        <ProviderCountrySelect width={400}   value={providerCountry ? [providerCountry] : []}

         includeAllOption={false} onChange={handleModalCountryChange} />

        <Select
         style={{ width: 400, marginBottom: 4 }}
                  autoFocus
                  placeholder="Select Type"
                  className={s.searchSelect}
                  size='large'
                onChange={(value) => handleTypeChange( value)}
                value={selectedType.current}
                
                  allowClear
             
                  
      
                >
                  {listOfEntityTypes.map((entity) => (
                    <Select.Option value={entity} key={entity} label={entity}>
                      {entity.name}
                    </Select.Option>
                  ))}
                </Select>
                {selectedType.current !== 'EVENT' && (
        <Select
          allowClear
          showSearch
        
          filterOption={false}
          onSearch={debounce(handleSearch, 500)}
          onSelect={handleSelect}
          size="large"
          placeholder="Search"
          labelInValue={true}
          value={
            selectedGame.current
              ? {
                  label: selectedGame.current.name,
                  value: selectedType?.current !== 'METAVERSE'
                    ? 0
                    : selectedGame.current.roomId,
                }
              : null
          }
          className={s.searchSelect}
          onClear={resetModal}
          loading={selectLoading.current}
        >
          {filteredResults?.map((item) => (
             <Option key={selectedType?.current === 'METAVERSE' ? item.roomId : item.id}>
                {selectedType?.current === 'METAVERSE' ? item.name : item.title}
           </Option>
          ))}
        </Select>
        )}
       {selectedType.current === 'EVENT' && (
  <Select
    allowClear
    showSearch
    size="large"
    placeholder="Select Event"
    className={s.searchSelect}
    loading={selectLoading.current}
    filterOption={(input, option) =>
      String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    }
    onSelect={(value, option) =>
      handleSelect({
        value,
        label: option?.label,
      })
    }
     options={filterEvents(events).map((event) => ({
      value: event.id,
      label: event.name,
    }))}
  />
)}

        </Space>
      </Modal>
    </>
  )
}

AddingModal.displayName = 'AddingModal'
export default AddingModal
